window.addEventListener('DOMContentLoaded', (event)=>{
    ($ => {
        $(document).ready(
        (() => {
            let lastUrl = location.href;
            new MutationObserver(() => {
                const url = location.href;
                if (url !== lastUrl) {
                    lastUrl = url;
                    //onUrlChange();
                }
            }).observe(document, { subtree: true, childList: true });
            const updateUrlParam = function (param, value) {
                const url = new URL(window.location);
                url.searchParams.set(param, value);
                window.history.replaceState({}, '', url);
            }
            // process the page heading
            const the_heading = $('.product__title').text();

            updateAdditionalWidth();
            updateAdditionalLength();
            updateVariant();
            updateFinishLevel();
            handleCheckOut();
            
            $(".thickness-select").change(function(e) {
                updateVariant();
            });
            
            $('input[name="thickness"]').on('change', function() {
                updateVariant();
                updateCustomBuildGallery();
            });
            
            $(".width-select").change(function (e) {
                updateAdditionalWidth();
                updateVariant();
            });
            
            $(".diameter-select").change(function(e) {
                updateVariant();
            });
            
            $(".length-select").change(function (e) {
                updateAdditionalLength();
                updateVariant();
            });
            
            $("#product-finish-level").change(function (e) {
                updateFinishLevel();
                updateVariant();
            });

            $('#product-additional-width, #product-additional-length').change(function(e) {
                var optionsWrapper = $(this).closest('.options-selection__select-wrapper');
                var value = $(this).val();

                if(value) {
                    if(!value.includes('No Change in Width') && !value.includes('No Change in Length') && !value.includes('Not Available')) {
                        value += '"';
                    }

                    if(value.includes('No Change in Width') || value.includes('No Change in Length') || value.includes('Not Available')) {
                        value = '';
                    }
    
                    if(optionsWrapper.length > 0) {
                        var selectedLabel = optionsWrapper.find('.selected-option-text');
                        if(selectedLabel.length > 0 && selectedLabel.text() != value) {
                            selectedLabel.text(value);
                        }
                    }

                    updateSizeTabLabel();
                }
            });

            $('#size-refinement-link').on('click', function(e) {
                e.preventDefault();
                $('.size-refinement-drawer').toggleClass('size-refinement-drawer-open');
            });

            $('.custom-build-swatch').on('click', function() {

                var swatch = $(this);

                var type = swatch.data('type');
                var value = swatch.data('value');
                if (type == 'finish_level') {
                    value = swatch.data('finishType');
                }

                var url = new URL(window.location.href);
                var params = new URLSearchParams(url.search);

                swatch.closest('.custom-builds-swatch-container').find('.custom-build-swatch').removeClass('custom-build-selected');
                swatch.addClass('custom-build-selected');
                params.set(type, value);

                if(type == 'wood_type') {
                    updateFinishSwatch(value);
                } else if (type == 'finish_level') {

                    params.delete('rubio_monocoat');
                    params.delete('satin_lacquer_sanding');

                    $('.custom-build-finish-options').removeClass('custom-build-finish-options-visible');
                    $('.custom-build-finish-options').find('.custom-build-rubio-monocoat-finish-swatch.custom-build-selected').removeClass('custom-build-selected');
                    $('#custom-build-satin-lacquer-sanding-smooth-sanded').prop('checked', true).change();

                    // Show/Hide Extra finishing options based on value
                    if(value == 'Satin Lacquer') {
                        // Show Satin Lacquer options and hide rubio Monocoat Options
                        $('#custom-build-satin-lacquer-options-container').addClass('custom-build-finish-options-visible');
                    } else if (value == 'Rubio Monocoat') {
                        // Show Rubio Monocoat options and hide Satin Lacquer otions
                        $('#custom-build-rubio-monocoat-options-container').addClass('custom-build-finish-options-visible');

                        // Preselect Natural Rubio Monocoat
                        var woodTypeSwatch = $('.custom-build-swatch-wood-type.custom-build-selected');
                        if(woodTypeSwatch.length > 0) {
                            var woodType = woodTypeSwatch.attr('data-value');
                            if(woodType) {
                                var pureRubioSwatch = $('.custom-build-swatch.custom-build-rubio-monocoat-finish-swatch[data-wood-type="' + woodType + '"][data-title="Pure Rubio Monocoat"]');
                                pureRubioSwatch.addClass('custom-build-selected');
                            }
                        }
                    }
                } else if (type == 'rubio_monocoat') {
                    // Custom rubio_monocoat logic
                }

                setHiddenSelect(swatch);

                window.calculateAddonPrice();
                updateCustomBuildPrices();

                if(type == 'wood_type') {
                    updateCustomBuildGallery();
                    updateTabLabelForSwatch(swatch);
                } else {
                    updateSwatchLabel(swatch);
                    updateFinishLevelTabLabel();
                }

                // Trigger Tooltip on mobile
                if(!window.matchMedia("(hover: hover)").matches) {
                    showToolTip(this);
                }

                url.search = params.toString();
                history.replaceState(null, '', url);
            });

            $('input[name="edge_type"]').on('change', function(){
                var hiddenSelect = $('#product-edge-type');
                var value = $(this).val();

                hiddenSelect.val(value).change();

                updateCustomBuildGallery();
                // updateLabelByVal($(this));
                updateTabLabelByVal($(this));
            });

            $('input[name="satin_lacquer_sanding"]').on('change', function() {
                var hiddenSelect = $('#custom-build-satin-lacquer-sanding');
                var value = $(this).val();

                hiddenSelect.val(value).change();

                window.calculateAddonPrice();
                updateCustomBuildPrices();
                updateLabelByLabelText($(this));
                updateFinishLevelTabLabel();
            });

            // Satin Lacquer Sanding hidden select to update url params 
            $("#custom-build-satin-lacquer-sanding").change((event) => {
                const $element = $(event.target);
                updateUrlParam('satin_lacquer_sanding', $element.val());
            });

            // Shows the tooltop for a swatch if it has one
            function showToolTip(swatch) {
                const $swatch = $(swatch);
                const $swatchWrapper = $swatch.closest('.swatch-wrapper');
                const $tooltip = $swatchWrapper.find('.swatch-tooltip');

                if($tooltip.length == 0) {
                    return;
                }

                if(!window.matchMedia("(hover: hover)").matches) {
                    hideAllToolTips();
                }

                const tooltipWidth = $tooltip.outerWidth();
                const tooltipHeight = $tooltip.outerHeight();
                const swatchOffset = $swatch.position(); 
                const swatchWidth = $swatch.outerWidth();
                const swatchHeight = $swatch.outerHeight();

                const swatchOffsetWindow = $swatch.offset();
            
                let leftPosition = swatchOffset.left + (swatchWidth / 2) - (tooltipWidth / 2);
                let topPosition = swatchOffset.top - tooltipHeight - 10; 

                let flexDirection = 'column';
                // Check if tooltip would go off the screen above
                if (swatchOffsetWindow.top + topPosition < 115) {
                    // Position the tooltip 10px below the swatch instead
                    topPosition = swatchOffset.top + $swatchWrapper.outerHeight() + 10;
                    flexDirection = 'column-reverse';
                }

                if (swatchOffsetWindow.left + leftPosition < 0) {
                    leftPosition = -swatchOffsetWindow.left + 5;
                }
            
                const windowWidth = $(window).width();
                if (swatchOffsetWindow.left + leftPosition + tooltipWidth > windowWidth) {
                    leftPosition = windowWidth - swatchOffsetWindow.left - tooltipWidth - 5;
                }
            
                $tooltip.css({
                    'visibility': 'visible',
                    'opacity': '1',
                    'position': 'absolute',
                    'left': leftPosition,
                    'top': topPosition,
                    'transform': 'none',
                    'width': '300px',
                    'display': 'unset',
                    'transition': 'opacity 0.5s',
                });
            }

            // Hides the tooltip for a swatch if it has one
            function hideToolTip(swatch) {
                const $swatchWrapper = $(swatch).closest('.swatch-wrapper');
                const $tooltip = $swatchWrapper.find('.swatch-tooltip');

                if($tooltip.length == 0) {
                    return;
                }

                $tooltip.css({
                    'display': 'none',
                    'visibility': 'hidden',
                    'opacity': '0',
                    'transition': 'display 0.5s'
                });
            }

            // hides all tooltips
            function hideAllToolTips() {
                $('.swatch-tooltip').css({
                    'display': 'none',
                    'visibility': 'hidden',
                    'opacity': '0',
                    'transition': 'display 0.5s'
                });
            }

            $('.custom-build-swatch').hover(function() {

                if(!window.matchMedia("(hover: hover)").matches) {
                    return;
                }

                showToolTip(this);

            }, function() {
                
                if(!window.matchMedia("(hover: hover)").matches) {
                    return;
                }

                hideToolTip(this);

            });

            function updateFinishSwatch(woodType, finishType = false) {
                
                if(!finishType) {
                    var selectedFinishSwatch = $('.custom-build-finishing-level-swatch.custom-build-selected[data-type="finish_level"]');

                    if(selectedFinishSwatch.length > 0) {
                        finishType = selectedFinishSwatch.data('finishType');
    
                        // Deselect finishing level
                        selectedFinishSwatch.removeClass('custom-build-selected');
                    }
                }

                // Find new finishing level for this wood type
                var newFinishVal = finishType + ' / ' + woodType;
                var newSelectedFinishSwatch = $('.custom-build-finishing-level-swatch[data-value="' + newFinishVal + '"]');
                if(newSelectedFinishSwatch.length > 0) {
                    newSelectedFinishSwatch.addClass('custom-build-selected');
                    setHiddenSelect(newSelectedFinishSwatch);
                }
                
                // Hide all finishing level swatches
                var finishngSelectWrapper = $('.finishing-swatch-wrapper');
                finishngSelectWrapper.addClass('custom-build-swatch-hidden');
                
                // Unhide all finishing level swatches of the new wood type
                var displayedFinishingSwatches = $('.custom-build-swatch[data-type="finish_level"][data-wood-type="' + woodType + '"]');
                displayedFinishingSwatches.each((index, displayedSwatch) => {
                    var displayedWrapper = $(displayedSwatch).closest('.finishing-swatch-wrapper');
                    displayedWrapper.removeClass('custom-build-swatch-hidden');
                });

                var newSelectedRubioSwatch = false;
                if(finishType == 'Rubio Monocoat') {
                    
                    // See if a rubio monocoat swatch is already selected and change it to the new wood type
                    var selectedRubioSwatch = $('.custom-build-swatch.custom-build-selected[data-type="rubio_monocoat"]');
                    if(selectedRubioSwatch.length > 0) {
                        selectedRubioSwatch.removeClass('custom-build-selected');

                        var title = selectedRubioSwatch.attr('data-title');

                        newSelectedRubioSwatch = $('.custom-build-rubio-monocoat-finish-swatch[data-title="' + title + '"][data-wood-type="' + woodType + '"]');
                        if(newSelectedRubioSwatch && newSelectedRubioSwatch.length > 0) {
                            newSelectedRubioSwatch.addClass('custom-build-selected');
                        }
                    }
                }

                // Hide all rubio monocoat swatches
                var rubioMonocoatWrapper = $('.rubio-monocoat-swatch-wrapper');
                rubioMonocoatWrapper.addClass('custom-build-swatch-hidden');
                
                // Unhide all rubio monocoat swatches of the new wood type
                var displayedRubioMonocoatSwatches = $('.custom-build-swatch[data-type="rubio_monocoat"][data-wood-type="' + woodType + '"]');
                displayedRubioMonocoatSwatches.each((index, displayedSwatch) => {
                    var displayedWrapper = $(displayedSwatch).closest('.rubio-monocoat-swatch-wrapper');
                    displayedWrapper.removeClass('custom-build-swatch-hidden');
                });

                // Show/Hide Extra finishing options based on finishType
                if(finishType == 'Satin Lacquer') {
                    // Show Satin Lacquer options and hide rubio Monocoat Options
                    $('#custom-build-rubio-monocoat-options-container').removeClass('custom-build-finish-options-visible');
                    $('#custom-build-satin-lacquer-options-container').addClass('custom-build-finish-options-visible');
                } else if (finishType == 'Rubio Monocoat') {
                    // Show Rubio Monocoat options and hide Satin Lacquer otions
                    $('#custom-build-satin-lacquer-options-container').removeClass('custom-build-finish-options-visible');
                    $('#custom-build-rubio-monocoat-options-container').addClass('custom-build-finish-options-visible');

                    if(!newSelectedRubioSwatch || newSelectedRubioSwatch.length <= 0) {
                        // Preselect Natural Rubio Monocoat
                        var woodTypeSwatch = $('.custom-build-swatch-wood-type.custom-build-selected');
                        if(woodTypeSwatch.length > 0) {
                            var woodType = woodTypeSwatch.attr('data-value');
                            if(woodType) {
                                var pureRubioSwatch = $('.custom-build-swatch.custom-build-rubio-monocoat-finish-swatch[data-wood-type="' + woodType + '"][data-title="Pure Rubio Monocoat"]');
                                pureRubioSwatch.addClass('custom-build-selected');
                            }
                        }
                    }
                    
                } else {
                    $('#custom-build-satin-lacquer-options-container').removeClass('custom-build-finish-options-visible');
                    $('#custom-build-rubio-monocoat-options-container').removeClass('custom-build-finish-options-visible');
                }

                // Set the finishing level text
                // updateSwatchLabel(newSelectedFinishSwatch);
                updateSwatchLabel(newSelectedFinishSwatch);
                updateFinishLevelTabLabel();
                // updateTabLabelForSwatch(newSelectedFinishSwatch);
            }

            function updateCustomBuildGallery() {
                var woodType = $('#hidden-product-wood-type').val();
                var thickness = $('input[name="thickness"]:checked').val();
                var edgeTypeVal = $('#product-edge-type').val();

                var edgeType = 'Straight Cut Edge';
                if(edgeTypeVal == 'Sculpted Live Edge 1 Side' || edgeTypeVal == 'Sculpted Live Edges Both Sides' || edgeTypeVal == 'Sculpted Live Edge') {
                    edgeType = 'Sculpted Live Edge';
                }
                
                var value = woodType + ' / ' + thickness + ' / ' + edgeType;

                var visibleImage = $('.custom-build-image-container.custom-build-image-selected');
                if(visibleImage.data('value') != value) {                    
                    var selectedImage = $(".custom-build-image-container[data-value='" + value + "']");
                    selectedImage.addClass('custom-build-image-selected');
                    visibleImage.removeClass('custom-build-image-selected');
                }
            }

            function setHiddenSelect($swatch) {
            
                var type = $swatch.data('type');
                var value = $swatch.data('value');

                var hiddenSelect = $('.hidden-custom-build-select[data-type="' +  type + '"]');
                hiddenSelect.val(value).change();
            }

            const urlSearchParams = new URLSearchParams(window.location.search);

            var woodType = 'Black Walnut';
            var finishLevel = 'Unfinished';
            var rubioMonocoat = false;
            var sandingFinish = false;

            urlSearchParams.forEach(function (value, key) {

                if(key == 'wood_type') {
                    woodType = value;
                } else if(key == 'finish_level') {
                    finishLevel = value;
                } else if(key == 'product-edge-type') {
                    const $edgeTypeInput = $('input[name="edge_type"][value="' + value + '"]');
                    
                    if($edgeTypeInput.length > 0) {
                        $edgeTypeInput.prop('checked', true).change();
                    }
                } else if(key == 'rubio_monocoat') {
                    rubioMonocoat = value;
                } else if(key == 'satin_lacquer_sanding') {
                    sandingFinish = value;
                } else {
                    // set the values from the url for preset variables
                    const $element = $('#' + key);
    
                    if($element.length > 0) {
                        // update select value and trigger the change handler function
                        $element.val(value).change();
                    }
                }
            });

            // Set wood type swatch
            var $woodTypeSwatch = $('.custom-build-swatch[data-type="wood_type"][data-value="' + woodType + '"]');
            if($woodTypeSwatch.length > 0) {
                $woodTypeSwatch.addClass('custom-build-selected');
                setHiddenSelect($woodTypeSwatch);
                // updateSwatchLabel($woodTypeSwatch);
                updateTabLabelForSwatch($woodTypeSwatch);
            }
                        
            // Select the saved sanding finish radio option
            if(sandingFinish) {
                var selectedSanding = $('input[name="satin_lacquer_sanding"][value="' + sandingFinish + '"]');
                if(selectedSanding.length > 0) {
                    selectedSanding.prop('checked', true).change();
                }
            }

            // Select the saved rubio monocoat swatch
            if(rubioMonocoat) {
                var selectedRubioMonocoat = $('.custom-build-swatch.custom-build-rubio-monocoat-finish-swatch[data-value="' + rubioMonocoat + '"]');
                if(selectedRubioMonocoat.length > 0) {
                    selectedRubioMonocoat.addClass('custom-build-selected');
                    updateSwatchLabel(selectedRubioMonocoat);
                }
            }
            
            // Set finish level
            updateFinishLevelTabLabel();
            updateFinishSwatch(woodType, finishLevel);
            updateCustomBuildGallery();
            window.calculateAddonPrice();
            updateCustomBuildPrices();
            
            // bind selects to update the url params on change
            jQuery("#product-variant-select-container").find('.js-dynamic-field').change((event) => {
                const $element = jQuery(event.target);
                updateUrlParam($element.attr('id'), $element.val());
            });

            // bind share button 
            jQuery("#share-this-product").click(function () {
                const shareData = {
                    title: 'LumberShack Custom Product',
                    text: 'LumberShack Custom Product',
                    url: window.location,
                }

                navigator.share(shareData);
            });
        })());

        function updateSizeTabLabel() {

            var sizeVal = "";

            // Update tab label
            var thicknessVal = $(".thickness-select").val();
            if(!thicknessVal || thicknessVal == '') {
                var $thickness = $('input[name="thickness"]:checked');
                thicknessVal = $thickness.val();
            }

            // remove 'Thickened Edge' if it's in the thicknessVal 
            if(thicknessVal.indexOf('Thickened Edge') > -1) {
                thicknessVal = thicknessVal.replace('Thickened Edge', '').trim();
            }
            
            sizeVal = thicknessVal;

            var $width = $(".width-select");
            if($width.length > 0) {
                const $additionalWidthSelect = $('#product-additional-width');
                if($additionalWidthSelect.length > 0 && $additionalWidthSelect.val() != 'No Change in Width' && $additionalWidthSelect.val() != 'Not Available') { 
                    sizeVal += " x " + $additionalWidthSelect.val() + '"';
                } else {
                    sizeVal += " x " + $width.val();
                }
            }

            var $length = $(".length-select");
            if($length.length > 0) {
                const $additionalLengthSelect = $('#product-additional-length');
                if($additionalLengthSelect.length > 0 && $additionalLengthSelect.val() != 'No Change in Length' && $additionalLengthSelect.val() != 'Not Available') { 
                    sizeVal += " x " + $additionalLengthSelect.val() + '"';
                } else {
                    sizeVal += " x " + $length.val();
                }
            }
            
            var $diameter = $('.diameter-select');
            if($diameter.length > 0) {
                sizeVal += " x " + $diameter.val();
            }

            // HERE
            let USDollar = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            // Get the current price for the unfinished variant option
            const hiddenVariantSelect = $('#hidden-custom-table-top-select');
            var variantOption = hiddenVariantSelect.find('option:selected');

            var unfinishedPrice = 0;
            var unfinishedPriceText = '';
            if(variantOption.length > 0) { 
                unfinishedPrice = parseFloat(variantOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                unfinishedPriceText = ' | ' + USDollar.format(unfinishedPrice);
                sizeVal += unfinishedPriceText;
            } 

            var tabLabel = $('.tab-label-cb[for="size-tab"]');
            if(tabLabel.length > 0) {
                var selectedOptionText = tabLabel.find('.selected-option-text');
                if(selectedOptionText.length > 0 && sizeVal != '' && selectedOptionText.text() != sizeVal) {
                    selectedOptionText.text(sizeVal);
                }
            }
        }

        function updateLabelByVal($element) {
            var value = $element.val();
            var optionsWrapper = $element.closest('.options-selection__select-wrapper');
            if(optionsWrapper.length > 0) {
                var selectedLabel = optionsWrapper.find('.selected-option-text');
                if(selectedLabel.length > 0 && selectedLabel.text() != value) {
                    selectedLabel.text(value);
                }
            }
        }

        function updateTabLabelByVal($element) { 
            var value = $element.val();

            var tabPanel = $element.closest('.tab-panel-cb');
            if(tabPanel.length > 0) {
                var tabId = tabPanel.data('tab-id');
                var tabLabel = $('.tab-label-cb[for="' + tabId + '"]');
                if(tabLabel.length > 0) {
                    var selectedOptionText = tabLabel.find('.selected-option-text');
                    if(selectedOptionText.length > 0 && value != '' && selectedOptionText.text() != value) {
                        selectedOptionText.text(value);
                    }
                }
            }
        }

        function updateLabelByLabelText($element) {
            var sandingId = $element.attr('id');
            if(sandingId) {
                var label = $('label[for="' + sandingId + '"]');
                if(label.length > 0) {
                    var labelValue = label.text();
                    
                    var optionsContainer = $element.closest('.options-selection__select');
                    if(optionsContainer.length > 0) {
                        var labelText = optionsContainer.find('.selected-option-text');
                        if(labelText.length > 0 && labelText.text() != labelValue) {
                            labelText.text(labelValue);
                        }
                    }
                }
            }
        }

        function updateTabLabelForSwatch($element) {
            var wrapper = $element.closest('.swatch-wrapper');
            if(wrapper.length > 0) {
                var labelValue = '';
                
                var tooltip = wrapper.find('.swatch-tooltip');
                if(tooltip.length > 0) {
                    labelValue = tooltip.text();
                } else {
                    var swatchLabel = wrapper.find('.swatch-label');
                    if(swatchLabel.length > 0) {
                        labelValue = swatchLabel.text();
                    }
                }

                var tabPanel = $element.closest('.tab-panel-cb');
                if(tabPanel.length > 0) {
                    var tabId = tabPanel.data('tab-id');
                    var tabLabel = $('.tab-label-cb[for="' + tabId + '"]');
                    if(tabLabel.length > 0) {
                        var selectedOptionText = tabLabel.find('.selected-option-text');
                        if(selectedOptionText.length > 0 && labelValue != '' && selectedOptionText.text() != labelValue) {
                            selectedOptionText.text(labelValue);
                        }
                    }
                }
            }
        }

        function updateFinishLevelTabLabel() {
            var selectedFinishLevel = $('.custom-build-finishing-level-swatch.custom-build-selected');
            if(selectedFinishLevel.length > 0) {
                var finishType = selectedFinishLevel.data('finishType');
                var labelValue = selectedFinishLevel.data('title');

                let USDollar = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

                // Get the current price for the unfinished variant option
                const hiddenVariantSelect = $('#hidden-custom-table-top-select');
                var variantOption = hiddenVariantSelect.find('option:selected');
    
                var unfinishedPrice = 0;
                var unfinishedPriceText = '';
                if(variantOption.length > 0) { 
                    unfinishedPrice = parseFloat(variantOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                    unfinishedPriceText = ' | ' + USDollar.format(unfinishedPrice);
                } 
                
                if(finishType == 'Unfinished') {
                    // labelValue += unfinishedPriceText;
                } else if(finishType == 'Sanded') {
                    // Get the current price for the sanding finishing option
                    const hiddenSandingSelect = $('#hidden-custom-build-sanding-select');
                    var sandingOption = hiddenSandingSelect.find('option:selected');
                    
                    var sandingPrice = 0;
                    if(sandingOption.length > 0) {
                        // sandingPrice = unfinishedPrice + parseFloat(sandingOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                        sandingPrice = parseFloat(sandingOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                        sandingPrice = ' +' + USDollar.format(sandingPrice);
                    }

                    labelValue += sandingPrice;

                } else if(finishType == 'Satin Lacquer') { 
                    var sanding = $("#custom-build-satin-lacquer-sanding").val();
                    labelValue += ' | ' + sanding;

                    // Get the current price for the finished finishing option
                    const hiddenFinishedLacquerSelect = $('#hidden-custom-build-finished-lacquer-select');
                    var finishedLacquerOption = hiddenFinishedLacquerSelect.find('option:selected');
                    
                    var finishedLacquerPrice = 0;
                    if(finishedLacquerOption.length > 0) {
                        // finishedLacquerPrice = unfinishedPrice + parseFloat(finishedLacquerOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                        finishedLacquerPrice = parseFloat(finishedLacquerOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                    }

                    // Check if rustic grinder finish is selected:
                    var rusticGrinderSelected = $('#custom-build-satin-lacquer-sanding-rustic-grinder-finish').is(':checked');
                    if(rusticGrinderSelected) {
                        // Get the current price for the Satin Lacquer - Grinder Finish finishing option 
                        const hiddenRusticGrinderSelect = $('#hidden-custom-build-rustic-grinder-select');
                        var rusticGrinderOption = hiddenRusticGrinderSelect.find('option:selected');
                        
                        if(rusticGrinderOption.length > 0) {
                            var rusticGrinderPrice = parseFloat(rusticGrinderOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                            finishedLacquerPrice += rusticGrinderPrice
                        }
                    }

                    labelValue += ' +' + USDollar.format(finishedLacquerPrice);


                } else if(finishType == 'Rubio Monocoat') {
                    var rubioSwatch = $('.custom-build-rubio-monocoat-finish-swatch.custom-build-selected');
                    if(rubioSwatch.length > 0) {
                        var rubioType = rubioSwatch.data('title');
                        labelValue += ' | ' + rubioType;

                        // Get the current price for the Stock Rubio Monocoat Color finishing option
                        const hiddenFinishedRubioSelect = $('#hidden-custom-build-finished-rubio-select');
                        var finishedRubioOption = hiddenFinishedRubioSelect.find('option:selected');
                        
                        var finishedRubioPrice = 0; 
                        if(finishedRubioOption.length > 0) {
                            // finishedRubioPrice = unfinishedPrice + parseFloat(finishedRubioOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                            finishedRubioPrice = parseFloat(finishedRubioOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                        }
                        
                        if(rubioType != 'Pure Rubio Monocoat') {
                            // Get the current price for the Addon Rubio Monocoat Color finishing option
                            const hiddenAddonRubioColorSelect = $('#hidden-custom-build-addon-rubio-colors-select');
                            var addonRubioOption = hiddenAddonRubioColorSelect.find('option:selected');
                            
                            if(addonRubioOption.length > 0) {
                                finishedRubioPrice += parseFloat(addonRubioOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                            }
                        }

                        labelValue += ' +' + USDollar.format(finishedRubioPrice);

                    }
                }

                var tabPanel = selectedFinishLevel.closest('.tab-panel-cb');
                if(tabPanel.length > 0) {
                    var tabId = tabPanel.data('tab-id');
                    var tabLabel = $('.tab-label-cb[for="' + tabId + '"]');
                    if(tabLabel.length > 0) {
                        var selectedOptionText = tabLabel.find('.selected-option-text');
                        if(selectedOptionText.length > 0 && labelValue != '' && selectedOptionText.text() != labelValue) {
                            selectedOptionText.text(labelValue);
                        }
                    }
                }
            }
        }

        function updateSwatchLabel($element) {
            var wrapper = $element.closest('.swatch-wrapper');
            if(wrapper.length > 0) {
                var labelValue = '';
                
                var tooltip = wrapper.find('.swatch-tooltip');
                if(tooltip.length > 0) {
                    labelValue = tooltip.text();
                } else {
                    var swatchLabel = wrapper.find('.swatch-label');
                    if(swatchLabel.length > 0) {
                        labelValue = swatchLabel.text();
                    }
                }

                var selectedFieldset = $element.closest('.custom-build-fieldset');
                if(selectedFieldset.length > 0) {
                    var selectedLabel = selectedFieldset.find('.selected-option-text');
                    if(selectedLabel.length > 0 && labelValue != '' && selectedLabel.text() != labelValue) {
                        selectedLabel.text(labelValue);
                    }
                }
            }        
        }

        // Update the extra custom build options' prices by the newly selected options
        function updateCustomBuildPrices() {

            let USDollar = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });
            
            // Get the current price for the unfinished variant option
            const hiddenVariantSelect = $('#hidden-custom-table-top-select');
            var variantOption = hiddenVariantSelect.find('option:selected');

            var unfinishedPrice = 0;
            var unfinishedPriceText = '';
            if(variantOption.length > 0) { 
                unfinishedPrice = parseFloat(variantOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                unfinishedPriceText = ' | ' + USDollar.format(unfinishedPrice);
            } 

            // Get the current price for the sanding finishing option
            const hiddenSandingSelect = $('#hidden-custom-build-sanding-select');
            var sandingOption = hiddenSandingSelect.find('option:selected');
            
            var sandingPrice = 0;
            if(sandingOption.length > 0) {
                // sandingPrice = unfinishedPrice + parseFloat(sandingOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                sandingPrice = parseFloat(sandingOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                sandingPrice = ' +' + USDollar.format(sandingPrice);
            }

            // Get the current price for the finished finishing option
            const hiddenFinishedLacquerSelect = $('#hidden-custom-build-finished-lacquer-select');
            var finishedLacquerOption = hiddenFinishedLacquerSelect.find('option:selected');
            
            var finishedLacquerPrice = 0;
            if(finishedLacquerOption.length > 0) {
                // finishedLacquerPrice = unfinishedPrice + parseFloat(finishedLacquerOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                finishedLacquerPrice = parseFloat(finishedLacquerOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                finishedLacquerPrice = ' +' + USDollar.format(finishedLacquerPrice);
            }

            // Get the current price for the Satin Lacquer - Grinder Finish finishing option 
            const hiddenRusticGrinderSelect = $('#hidden-custom-build-rustic-grinder-select');
            var rusticGrinderOption = hiddenRusticGrinderSelect.find('option:selected');
            
            var rusticGrinderPrice = 0;
            if(rusticGrinderOption.length > 0) {
                rusticGrinderPrice = parseFloat(rusticGrinderOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                rusticGrinderPrice = ' +' + USDollar.format(rusticGrinderPrice);
            }
            
            // Get the current price for the Stock Rubio Monocoat Color finishing option
            const hiddenFinishedRubioSelect = $('#hidden-custom-build-finished-rubio-select');
            var finishedRubioOption = hiddenFinishedRubioSelect.find('option:selected');
            
            var finishedRubioPrice = 0; 
            if(finishedRubioOption.length > 0) {
                // finishedRubioPrice = unfinishedPrice + parseFloat(finishedRubioOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                finishedRubioPrice = parseFloat(finishedRubioOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                finishedRubioPrice = ' +' + USDollar.format(finishedRubioPrice);
            }
            
            // Get the current price for the Addon Rubio Monocoat Color finishing option
            const hiddenAddonRubioColorSelect = $('#hidden-custom-build-addon-rubio-colors-select');
            var addonRubioOption = hiddenAddonRubioColorSelect.find('option:selected');
            
            var addonRubioPrice = 0;
            if(addonRubioOption.length > 0) {
                addonRubioPrice = parseFloat(addonRubioOption.attr('data-variant-price').replace(/[^0-9.]/g, ''));
                addonRubioPrice = ' +' + USDollar.format(addonRubioPrice);
            }
            
            var finishingUpdated = false;

            // Update Finishing Type Swatches
            $('.custom-build-finishing-level-swatch[data-finish-type="Unfinished"]').each((index, element) => {
                var priceText = $(element).closest('.finishing-swatch-wrapper').find('.tooltip-text-price');
                if(priceText.length > 0) {
                    // priceText.text(unfinishedPriceText);
                    finishingUpdated = true;
                }
            });

            // Update Finishing Type Swatches
            $('.custom-build-finishing-level-swatch[data-finish-type="Sanded"]').each((index, element) => {
                var priceText = $(element).closest('.finishing-swatch-wrapper').find('.tooltip-text-price');
                if(priceText.length > 0) {
                    priceText.text(sandingPrice);
                    finishingUpdated = true;
                }
            });

            $('.custom-build-finishing-level-swatch[data-finish-type="Satin Lacquer"]').each((index, element) => {
                var priceText = $(element).closest('.finishing-swatch-wrapper').find('.tooltip-text-price');
                if(priceText.length > 0) {
                    priceText.text(finishedLacquerPrice);
                    finishingUpdated = true;
                }
            });

            $('.custom-build-finishing-level-swatch[data-finish-type="Rubio Monocoat"]').each((index, element) => {
                var priceText = $(element).closest('.finishing-swatch-wrapper').find('.tooltip-text-price');
                if(priceText.length > 0) {
                    priceText.text(finishedRubioPrice);
                    finishingUpdated = true;
                }
            });

            // Update the finishing label's price
            if(finishingUpdated) {
                var selectedSwatch = $('.custom-build-swatch.custom-build-finishing-level-swatch.custom-build-selected');
                if(selectedSwatch.length > 0) {
                    updateSwatchLabel(selectedSwatch);
                }
            }

            // Update Rustic Grinder Finish Radios
            var rusticGrinderText = $('label[for="custom-build-satin-lacquer-sanding-rustic-grinder-finish"]').find('.radio-addon-price-label');
            if(rusticGrinderText.length > 0) {
                rusticGrinderText.text(rusticGrinderPrice);

                // Update the Satin Lacquer Sanding label
                var satinLacquerSanding = $('input[name="satin_lacquer_sanding"]:checked');
                if(satinLacquerSanding.length > 0) {
                    updateLabelByLabelText(satinLacquerSanding); 
                }
            }

            var rubioMonocoatUpdated = false;

            // Update Rubio Monocoat Swatches
            $('.custom-build-swatch.custom-build-rubio-monocoat-finish-swatch').each((index, element) => {
                var wrapper = $(element).closest('.swatch-wrapper');
                if(wrapper.length > 0) {
                    var priceText = wrapper.find('.tooltip-text-price');
                    if(priceText.length > 0) {
                        var isStockColor = $(element).attr('data-is-stock-color');
    
                        if(isStockColor == 'true') {
                            priceText.text('');
                        } else {
                            priceText.text(addonRubioPrice);
                        }
                        rubioMonocoatUpdated = true;
                    }
                }  
            });

            if(rubioMonocoatUpdated) {
                var selectedRubioMonocoat = $('.custom-build-swatch.custom-build-rubio-monocoat-finish-swatch.custom-build-selected');
                if(selectedRubioMonocoat.length > 0) {
                    updateSwatchLabel(selectedRubioMonocoat);
                }
            }
        }

        function updateVariant() {
            const hiddenSelect = $('#hidden-custom-table-top-select');
            const hiddenSandingSelect = $('#hidden-custom-build-sanding-select');
            const hiddenFinishedLacquerSelect = $('#hidden-custom-build-finished-lacquer-select');
            const hiddenRusticGrinderSelect = $('#hidden-custom-build-rustic-grinder-select');
            const hiddenFinishedRubioSelect = $('#hidden-custom-build-finished-rubio-select');
            const hiddenAddonRubioColorSelect = $('#hidden-custom-build-addon-rubio-colors-select');

            var thicknessVal = $(".thickness-select").val();
            if(!thicknessVal || thicknessVal == '') {
                var $thickness = $('input[name="thickness"]:checked');
                thicknessVal = $thickness.val();
                updateLabelByVal($thickness);
            }

            var $width = $(".width-select");
            if($width.length > 0) {
                updateLabelByVal($width);
            }

            var $length = $(".length-select");
            if($length.length > 0) {
                updateLabelByVal($length);
            }
            
            var $diameter = $('.diameter-select');
            if($diameter.length > 0) {
                updateLabelByVal($diameter);
            }

            const valueToSelect = thicknessVal + " / " + $width.val() + " / " + $length.val();
            const valueToSelectDiameter = thicknessVal + " / " + $diameter.val();

            const addToCartButton = $('#product-add-to-cart-button');
            const addToCartButtonSticky1 = $('#product-add-to-cart-button-sticky-1');
            const addToCartButtonSticky2 = $('#product-add-to-cart-button-sticky-2');

            var optionFound = false;
            hiddenSelect.find('option').each(function() {
                if (this.text === valueToSelect || this.text === valueToSelectDiameter) {
                    $(this).prop('selected', true);
                    optionFound = true;
                    return false;
                }
            });

            hiddenSandingSelect.find('option').each(function() {
                if(this.text === valueToSelect || this.text === valueToSelectDiameter) {
                    $(this).prop('selected', true);
                    return false;
                }
            });
            
            hiddenFinishedLacquerSelect.find('option').each(function() {
                if(this.text === valueToSelect || this.text === valueToSelectDiameter) {
                    $(this).prop('selected', true);
                    return false;
                }
            });

            hiddenRusticGrinderSelect.find('option').each(function() {
                if(this.text === valueToSelect || this.text === valueToSelectDiameter) {
                    $(this).prop('selected', true);
                    return false;
                }
            });

            hiddenFinishedRubioSelect.find('option').each(function() {
                if(this.text === valueToSelect || this.text === valueToSelectDiameter) {
                    $(this).prop('selected', true);
                    return false;
                }
            });

            hiddenAddonRubioColorSelect.find('option').each(function() {
                if(this.text === valueToSelect || this.text === valueToSelectDiameter) {
                    $(this).prop('selected', true);
                    return false;
                }
            });

            if(optionFound) {
                addToCartButton?.prop('disabled', false).text('Add to cart');
                addToCartButtonSticky1?.prop('disabled', false).text('Add to cart');
                addToCartButtonSticky2?.prop('disabled', false).text('Add to cart');
                
                const selectedOption = hiddenSelect.find('option:selected');
                const selectedVariant = selectedOption.val();
                const price = selectedOption.data('variant-price');
                const compareAtPrice = selectedOption.data('variant-compare-at-price');

                variantPrice = parseFloat(price.replace(/[^0-9.]/g, ''));
                variantCompareAtPrice = parseFloat(compareAtPrice.replace(/[^0-9.]/g, ''));

                const url = new URL(window.location);
                url.searchParams.set('variant', selectedVariant);
                window.history.replaceState({}, '', url);

                $('#booster-hidden-variant-input').val(selectedVariant);

                if(typeof window.calculateAddonPrice === 'function') {
                    window.calculateAddonPrice();
                } else {
                    $('.product-total-compare-at-price').each(function() {
                        $(this).text(compareAtPrice);
                    });
    
                    $('.product-total-price').each(function() {
                        $(this).text(price);
                    });
                }

                updateCustomBuildPrices();
                updateFinishLevelTabLabel();
            } else {
                addToCartButton?.prop('disabled', true).text('Unavailable');
                addToCartButtonSticky1?.prop('disabled', true).text('Unavailable');
                addToCartButtonSticky2?.prop('disabled', true).text('Unavailable');
            }

            updateSizeTabLabel();
        }

        function onUrlChange() {
            const updateUrlParam = function (param, value) {
                const url = new URL(window.location);
                url.searchParams.set(param, value);
                window.history.replaceState({}, '', url);
            }
            $('.js-dynamic-field').each(function (index, element) {
                const $element = $(element);
                updateUrlParam($element.attr('id'), $element.val());
            });
        }

        function updateAdditionalWidth() {

            const generate_option_text = function (option_value_number) {
                if (option_value_number === parseInt(option_value_number, 10)) {
                    return option_value_number.toString() + '"';
                }
                return `${Math.trunc(option_value_number)} 1/2"`;
            };
            const generate_select_options = function (range_start, range_end, step = .5) {
                if (range_start === range_end) return '';

                let current_option_number = range_start + step;
                let current_option_text = generate_option_text(current_option_number);
                let out_options = '';

                while (current_option_number < range_end) {
                    out_options += `<option value="${current_option_text}">${current_option_text}</option>`;
                    current_option_number += step;
                    current_option_text = generate_option_text(current_option_number);
                }

                return out_options;
            };

            const $widthSelect = $(".width-select");
            const $additionalWidthSelect = $('#product-additional-width');
            const widthSelectedOptionIndex = $widthSelect.prop('selectedIndex');
            const widthSelectedOption = parseInt($widthSelect.val());
            const widthPreviousOption = parseInt($widthSelect.find('option').eq(widthSelectedOptionIndex - 1).val());
            const widthOptions = generate_select_options(widthPreviousOption, widthSelectedOption);
            
            const url = new URL(window.location);
            var widthValue = url.searchParams.get('product-additional-width');

            $additionalWidthSelect.empty();
            if (widthOptions === '') {
                $additionalWidthSelect.append('<option value="Not Available">Not Available</option>');

                widthValue = 'Not Available';
            } else {
                $additionalWidthSelect.append('<option value="No Change in Width">No Change in Width</option>').append(widthOptions);

                if(!widthValue || widthValue == '' || !widthOptions.includes(widthValue)) {
                    widthValue = 'No Change in Width';
                }
            }

            $additionalWidthSelect.val(widthValue).change();

            url.searchParams.set('product-additional-width', widthValue);
            window.history.replaceState({}, '', url);

            if(widthValue == 'No Change in Width' || widthValue == 'Not Available') {
                widthValue = '';
            }

            var optionsWrapper = $additionalWidthSelect.closest('.options-selection__select-wrapper');
            if(optionsWrapper.length > 0) {
                var selectedLabel = optionsWrapper.find('.selected-option-text');
                if(selectedLabel.length > 0 && selectedLabel.text() != widthValue) {
                    selectedLabel.text(widthValue);
                }
            }
        }

        function updateAdditionalLength() {
            const generate_option_text = function (option_value_number) {
                if (option_value_number === parseInt(option_value_number, 10)) {
                    return option_value_number.toString() + '"';
                }
                return `${Math.trunc(option_value_number)} 1/2"`;
            };
            const generate_select_options = function (range_start, range_end, step = .5) {
                if (range_start === range_end) return '';

                let current_option_number = range_start + step;
                let current_option_text = generate_option_text(current_option_number);
                let out_options = '';

                while (current_option_number < range_end) {
                    out_options += `<option value="${current_option_text}">${current_option_text}</option>`;
                    current_option_number += step;
                    current_option_text = generate_option_text(current_option_number);
                }

                return out_options;
            };
            const $lengthSelect = $(".length-select");

            const $additionalLengthSelect = $('#product-additional-length');

            const lengthSelectedOptionIndex = $lengthSelect.prop('selectedIndex');
            const lengthSelectedOption = parseInt($lengthSelect.val());
            const lengthPreviousOption = parseInt($lengthSelect.find('option').eq(lengthSelectedOptionIndex - 1).val());

            const url = new URL(window.location);
            var lengthValue = url.searchParams.get('product-additional-length');

            $additionalLengthSelect.empty();
            const lengthOptions = generate_select_options(lengthPreviousOption, lengthSelectedOption, 1);
            if (lengthOptions === '') {
                $additionalLengthSelect.append('<option value="Not Available">Not Available</option>');
                
                lengthValue = 'Not Available';
            } else {
                $additionalLengthSelect.append('<option value="No Change in Length">No Change in Length</option>').append(lengthOptions);
                
                if(!lengthValue || lengthValue == '' || !lengthOptions.includes(lengthValue)) {
                    lengthValue = 'No Change in Length';
                }
            }

            $additionalLengthSelect.val(lengthValue).change();

            url.searchParams.set('product-additional-length', lengthValue);
            window.history.replaceState({}, '', url);

            if(lengthValue == 'No Change in Length' || lengthValue == 'Not Available') {
                lengthValue = '';
            }

            var optionsWrapper = $additionalLengthSelect.closest('.options-selection__select-wrapper');
            if(optionsWrapper.length > 0) {
                var selectedLabel = optionsWrapper.find('.selected-option-text');
                if(selectedLabel.length > 0 && selectedLabel.text() != lengthValue) {
                    selectedLabel.text(lengthValue);
                }
            }
        }

        function updateFinishLevel() {
            const $finishLevelSelect = $("#product-finish-level");
            const $sandingFinish = $('#product-sanding-finish');

            $sandingFinish.empty();

            if ($finishLevelSelect.val() === 'Unfinished/DIY') {
                $sandingFinish.empty().append('<option value="Not Available">Not Available</option>');
            } else {
                $sandingFinish.empty().append('<option value="Smooth Flat Surface">Smooth Flat Surface</option><option value="Rustic Grinder Finish">Rustic Grinder Finish</option>');
            }
        }

        /**
         *  when add to cart button is clicked it checks if agree to terms check box is checked and then 
         *  adds hidden inputs for each of the additional dynamic selectors
         */
        function handleCheckOut() {

            const $atcButton = $('#product-atc-btn');
            const $agreeTerms = $('#agree-terms');
            $atcButton.click(function () {
                // make sure terms and conditions agreement is checked
                if (!$agreeTerms.is(":checked")) {
                    alert("Please agree to the terms and conditions!");
                    return false;
                }
                // add inputs to the form 
                const variantInputsWrapper = jQuery("#product-variant-select-container");
                $(".dynamic-input").remove();
                // create hidden inputs for all of our marked selects
                $('.js-dynamic-field').each(function (index, element) {
                    const label_text = $("label[for='" + $(element).attr('id') + "']").text();
                    const value = $(element).val();
                    variantInputsWrapper.append(`<input class="dynamic-input" type="hidden" name="properties[${label_text}]" value="${value}"/>`);
                });
            });
        }

        function handleParams() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            urlSearchParams.forEach(function (value, key) {
                // set the values from the url for preset variables
                const $element = jQuery('#' + key);
                $element.val(value);
                // trigger the change handler function
                $element.change();
            });

            // bind selects to update the url params on change
            jQuery("#product-variants").find('select').change((event) => {
                const $element = jQuery(event.target);
                updateUrlParam($element.attr('id'), $element.val());
            });

            // bind share button 
            jQuery("#share-this-product").click(function () {
                const shareData = {
                    title: 'LumberShack Custom Product',
                    text: 'LumberShack Custom Product',
                    url: window.location,
                }

                navigator.share(shareData);
            });
        }

        // Add click listeners to allow the description tabs to be closed
        const customBuildTabRadios = document.querySelectorAll('.tab-radio-cb');
        customBuildTabRadios.forEach(tab => {
            tab.addEventListener('click', function(event){
                
                const isChecked = this.getAttribute('data-is-checked') === 'true';

                customBuildTabRadios.forEach(otherTab => {
                    otherTab.checked = false;
                    otherTab.setAttribute('data-is-checked', 'false');
                });    

                if (isChecked) {
                    this.checked = false;
                    this.setAttribute('data-is-checked', 'false');
                } else {
                    this.checked = true;
                    this.setAttribute('data-is-checked', 'true');

                    // Calculate the header offset to prevent the scroll from hiding text behind the header
                    var headers = document.querySelectorAll('.page__main__header');
                    var headerHeight = 10;
                    headers.forEach(header => {
                        if(header.style.display != 'none') {
                            headerHeight += header.offsetHeight;
                            return;
                        }
                    });

                    /* STICKY CUSTOM BUILD IMAGE
                    if(window.innerWidth <= 767) {
                        var customGallery = document.querySelector('.custom-builds-gallery');
                        if(customGallery) {
                            headerHeight += customGallery.offsetHeight;
                        }
                    }
                    */

                    if(window.innerWidth <= 767) {
                        // Scroll to the top of the label
                        const label = document.querySelector(`.tab-label-cb[for="${this.id}"]`);
                        const labelPosition = window.scrollY + label.getBoundingClientRect().top - headerHeight;

                        window.scrollTo({
                            top: labelPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        })
    })(jQuery);
});